export const environment = {
  production: true,
  apiUrl: '../api/configuration/serviceUrl',
  configFile: './config_tpl.json'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts